<template>
  <Modal class="packs-video-modal" icon="video" :title="$t('packs.videoModal.title')" @close="$emit('close')">
    <template #text>
      <!-- Плейсхолдер видео (само видео пока не вставляем) -->
      <div class="packs-video-modal__screen">
        <div class="packs-video-modal__play">
          <span class="packs-video-modal__play-icon" />
        </div>
        <div class="packs-video-modal__placeholder">{{ $t('packs.videoModal.placeholder') }}</div>
      </div>

      <div class="packs-video-modal__timecodes">
        <button v-for="tc in timecodes" :key="tc" class="packs-video-modal__timecode" type="button">
          {{ tc }}
        </button>
      </div>
    </template>

    <template #footer>
      <Button @click="$emit('close')">{{ $t('general.gotIt') }}</Button>
    </template>
  </Modal>
</template>

<script>
import './packsVideoModal.scss'

import Modal from '@/components/Base/Modal/modal.vue'
import Button from '@/components/Base/Button/Button.vue'

export default {
  name: 'PacksVideoModal',
  components: { Modal, Button },
  computed: {
    timecodes() {
      return [
        this.$t('packs.videoModal.timecodes.security'),
        this.$t('packs.videoModal.timecodes.email'),
        this.$t('packs.videoModal.timecodes.codes')
      ]
    }
  }
}
</script>
